<template>
  <div v-if="planDataIsRetrieved">
    <v-alert
      :value="checkIfDepartmentIsArchived"
      color="warning"
      icon="priority_high"
      outline
      class="headline"
    >
      Advarsel! Avdelingen er ikke i bruk, du vil derfor ikke få til å redigere planen.
    </v-alert>
    <!-- <v-btn block color="info" :disabled="!registeredchanges" @click="submitEditPlan">Lagre plan</v-btn> -->
    <!-- <pre v-text="plan"></pre> -->
    <v-tabs grow class="mb-4" v-model="activeTab">
      <v-tab ripple>{{ planTitle }}</v-tab>
      <v-tab ripple>{{ GET_ORDLYD && GET_ORDLYD.main_evaluering }}</v-tab>
      <v-tab ripple>{{ GET_ORDLYD && GET_ORDLYD.org_virksomhet_target }}</v-tab>
      <v-tab ripple>Planlegge</v-tab>
      <v-tab ripple>Utføre</v-tab>
    
      <v-tab-item>
        <v-layout row wrap>
          <v-flex xs12 pt-3>
            <v-card>
              <v-card-text v-html="planDescription"></v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 pt-3>
            <v-card>
              <v-layout row wrap pa-2>
                <v-flex xs12 sm3 pb-0>
                  <v-text-field
                    :disabled="checkIfPlanIsArchived"
                    v-model="Response.ParentOrg"
                    :label="GET_ORDLYD && GET_ORDLYD.org_area"
                    @input="registeredchanges = true"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 pb-0>
                  <v-text-field
                    :disabled="checkIfPlanIsArchived"
                    @input="registeredchanges = true"
                    v-model="Response.Org"
                    :label="GET_ORDLYD && GET_ORDLYD.org_department"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 pb-0>
                  <v-text-field
                    :disabled="checkIfPlanIsArchived"
                    @input="registeredchanges = true"
                    class="lime lighten-3"
                    v-model="Response.Place"
                    :label="GET_ORDLYD && GET_ORDLYD.place"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 pb-0>
                  <v-menu
                    v-model="DateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :disabled="checkIfPlanIsArchived"
                        class="lime lighten-3"
                        v-model="Response.Date"
                        :label="GET_ORDLYD && GET_ORDLYD.date"
                        readonly
                        v-on="on"
                        @input="registeredchanges = true"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :disabled="checkIfPlanIsArchived"
                      v-model="Response.Date"
                      @input="
                        DateMenu = false;
                        registeredchanges = true;
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 pt-0>
                  <v-text-field
                    :disabled="checkIfPlanIsArchived"
                    v-model="Response.Participants"
                    :label="GET_ORDLYD && GET_ORDLYD.participiants"
                    class="lime lighten-3"
                    persistent-hint
                    :hint="GET_ORDLYD && GET_ORDLYD.help_participiants"
                    @input="registeredchanges = true"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 pt-3>
            <v-card>
              <v-card-title>{{
                GET_ORDLYD && GET_ORDLYD.fagressurser
              }}</v-card-title>
              <v-card-text>
                <v-data-table :items="plan.resources" hide-actions>
                  <template v-slot:headers>
                    <tr>
                      <th align="left">
                        {{
                          GET_ORDLYD &&
                          GET_ORDLYD.fagressurser_kode.toUpperCase()
                        }}
                      </th>
                      <th align="left">
                        {{
                          GET_ORDLYD &&
                          GET_ORDLYD.fagressurser_beskrivelse.toUpperCase()
                        }}
                      </th>
                      <th align="left">
                        {{
                          GET_ORDLYD &&
                          GET_ORDLYD.fagressurser_kontakt.toUpperCase()
                        }}
                      </th>
                      <th align="left">
                        {{
                          GET_ORDLYD &&
                          GET_ORDLYD.fagressurser_epost.toUpperCase()
                        }}
                      </th>
                      <th align="left">
                        {{
                          GET_ORDLYD &&
                          GET_ORDLYD.fagressurser_telefon.toUpperCase()
                        }}
                      </th>
                    </tr>
                  </template>
                  <template v-slot:items="props">
                    <!-- <div>{{props.item}}</div> -->
                    <tr>
                      <td>{{ props.item.abbreviation }}</td>
                      <td>{{ props.item.description }}</td>
                      <td>{{ props.item.contact }}</td>
                      <td>{{ props.item.email }}</td>
                      <td>{{ props.item.phone }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-tab-item>
      <v-tab-item>
        <!-- Evaluering -->
        <h1 class="pt-3">
          {{ GET_ORDLYD && GET_ORDLYD.evaluering_overskrift }}
        </h1>

        <v-layout
          row
          wrap
          v-for="task in plan.evaluationtasks"
          :key="task.id"
          justify-center
          align-space-around
          class="mb-3"
          :class="{
            'green lighten-2': task.completed == 1,
            'red darken-1 white--text': task.completed == 2,
          }"
        >
          <v-flex
            xs10
            d-flex
            align-center
            @click="task.completed = !task.completed"
            px-2
          >
            <h2 v-text="task.question"></h2>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex>
            <v-radio-group :disabled="checkIfPlanIsArchived" v-model="task.completed" row>
              <v-radio
                label="Ja"
                color="black"
                :value="1"
                @change="registeredchanges = true"
              >
                <template v-slot:label>
                  <strong :class="{ 'white--text': task.completed == 2 }"
                    >Ja</strong
                  >
                </template>
              </v-radio>
              <v-radio
                label="Nei"
                :color="task.completed == 2 ? 'white' : 'black'"
                :value="2"
                @change="registeredchanges = true"
              >
                <template v-slot:label>
                  <strong :class="{ 'white--text': task.completed == 2 }"
                    >Nei</strong
                  >
                </template>
              </v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex xs12>
            <v-textarea
              :disabled="checkIfPlanIsArchived"
              label="Kommentar"
              class="lime lighten-3"
              v-model="task.text"
              @input="registeredchanges = true"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-tab-item>
      <v-tab-item>
        <!-- Målsetting -->

        <v-layout row wrap>
          <v-flex xs12 pt-3>
            <div v-html="plan.planning.overordna_maalsetting"></div>
          </v-flex>
          <v-flex xs12 pt-3>
            <div v-html="plan.planning.avd_maalsetting"></div>
          </v-flex>

          <v-flex xs12 sm6 pt-3>
            <v-textarea
              :disabled="checkIfPlanIsArchived"
              :label="GET_ORDLYD && GET_ORDLYD.org_avdeling_target"
              class="lime lighten-3"
              @input="registeredchanges = true"
              v-model="Response.avd_maal_frafall_reduksjon"
            ></v-textarea>
          </v-flex>
          <v-flex xs12 sm6 pt-3>
            <v-textarea
            :disabled="checkIfPlanIsArchived"
              :label="GET_ORDLYD && GET_ORDLYD.org_avdeling_subtarget"
              class="lime lighten-3"
              @input="registeredchanges = true"
              v-model="Response.avd_delmaal_frafall_reduksjon"
            ></v-textarea>
          </v-flex>
          <v-flex xs12 pt-3>
            <v-data-table :items="absenceGoals" hide-actions>
              <template v-slot:headers>
                <tr>
                  <th align="left">
                    {{
                      GET_ORDLYD &&
                      GET_ORDLYD.org_avdeling_tilstedeverelse_target
                    }}
                  </th>
                  <th style="width:25%;" align="left">
                    {{
                      GET_ORDLYD &&
                      GET_ORDLYD.org_avdeling_tilstedeverelse_target_short
                    }}
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <tr>
                  
                  <td v-if="plan.planning.year !== undefined && props.index <= 2">Måltall {{ Number(plan.planning.year) + 2 - props.index}}</td>
                  <td v-if="plan.planning.year !== undefined && props.index > 2">Nærvær {{ Number(plan.planning.year) + 2 - props.index}}</td>

                  <td class="lime lighten-3">
                    <v-edit-dialog :return-value="props.item.shortabsence">
            
                      {{ Number(props.item.shortabsence).toFixed(2) + " %" }}
                      <template v-slot:input>
                        <v-text-field
                          :disabled="checkIfPlanIsArchived"
                          v-model.number="props.item.shortabsence"
                          single-line
                          @focus="$event.target.select()"
                          @input="registeredchanges = true"
                          type="number"
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <p class="pt-3">
              <strong>
                 Bruk rapport: HMS/IA plan fravær i Visma HRM 
              </strong>
            </p>
          </v-flex>
        </v-layout>
      </v-tab-item>
      <v-tab-item>
        <!-- Planlegging -->
        <h2 pt-3>{{ GET_ORDLYD && GET_ORDLYD.org_overview }}</h2>
        <!-- Kommunens overordna oversikt -->
        <v-data-table
          class="overordna_aktivitet"
          :items="overordna_aktivitet"
          hide-actions
        >
          <template v-slot:headers>
            <tr class="green lighten-1">
              <th align="left" style="width: 20%;">
                {{ GET_ORDLYD && GET_ORDLYD.schedule }}
              </th>
              <th align="left" style="width: 15%;">
                {{ GET_ORDLYD && GET_ORDLYD.category }}
              </th>
              <th style="width:40%;" align="left">
                {{ GET_ORDLYD && GET_ORDLYD.measure }}
              </th>
              <th align="left">
                {{ GET_ORDLYD && GET_ORDLYD.responsibility }}
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr class="green lighten-2">
              <td>{{ props.item.schedule }}</td>
              <td>{{ props.item.category }}</td>
              <td>{{ props.item.measure }}</td>
              <td>{{ props.item.responsibility }}</td>
            </tr>
          </template>
        </v-data-table>
        <h2>
          {{ GET_ORDLYD && GET_ORDLYD.org_avdeling_mandatory_activities }}
        </h2>
        <v-data-table class="avd_aktivitet" :items="avd_aktivitet" hide-actions>
          <template v-slot:headers>
            <th align="left" style="width: 20%;">
              {{ GET_ORDLYD && GET_ORDLYD.schedule }}
            </th>
            <th align="left" style="width: 15%;">
              {{ GET_ORDLYD && GET_ORDLYD.category }}
            </th>
            <th style="width:40%;" align="left">
              {{ GET_ORDLYD && GET_ORDLYD.measure }}
            </th>
            <th align="left">{{ GET_ORDLYD && GET_ORDLYD.responsibility }}</th>
          </template>
          <template v-slot:items="props">
            <tr>
              <td class="lime lighten-3">
                <v-select
                  :disabled="checkIfPlanIsArchived"
                  :items="maanedsvalg"
                  v-model="props.item.schedule"
                  @change="registeredchanges = true"
                ></v-select>
              </td>
              <td>{{ props.item.category }}</td>
              <td>{{ props.item.measure }}</td>
              <td>{{ props.item.responsibility }}</td>
            </tr>
          </template>
        </v-data-table>

        <h2>{{ GET_ORDLYD && GET_ORDLYD.org_avdeling_other_activities }}</h2>
        <v-data-table
          class="avd_ovrige_aktiviter"
          :items="Response.avd_ovrige_aktiviter"
          hide-actions
        >
          <template v-slot:headers>
            <th style="width: 20%;" align="left">
              {{ GET_ORDLYD && GET_ORDLYD.schedule}}
            </th>
            <th style="width: 15%;" align="left">
              {{ GET_ORDLYD && GET_ORDLYD.time_estimate}}
            </th>
            <th style="width: 15%;" align="left">
              {{ GET_ORDLYD && GET_ORDLYD.category }}
            </th>
            <th style="width: 15%;" align="left">
                Spørsmål
            </th>
            <th style="width:40%;" align="left">
              {{ GET_ORDLYD && GET_ORDLYD.measure }}
            </th>
            <th style="width:15%;" align="left">
              {{ GET_ORDLYD && GET_ORDLYD.responsibility }}
            </th>
          </template>
          
          <template v-slot:items="props">
            <td class="lime lighten-3">
              <v-select
                :disabled="checkIfPlanIsArchived"
                :items="maanedsvalg"
                v-model="props.item.schedule"
                @change="registeredchanges = true"
              ></v-select>
            </td>
            <td class="lime lighten-3">
              <v-text-field 
                :disabled="checkIfPlanIsArchived"
                v-model="props.item.timeEstimate"
                type="number"
                step="0.5"
                @input="registeredchanges = true"
                suffix="timer"
                single-line>
              </v-text-field>
            </td>
            <td class="lime lighten-3">
              <v-menu
                v-model="props.item.CategoryMenu_avd_ovrige_aktiviter"
                :close-on-content-click="true"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-btn block flat v-on="on" :disabled="checkIfPlanIsArchived">
                    {{
                      props.item.category ||
                      ("Velg " + GET_ORDLYD &&
                        GET_ORDLYD.category.toLowerCase())
                    }}
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile
                    v-for="(item, index) in plan.categories"
                    :key="index"
                    @click="
                      props.item.category = item.category;
                      registeredchanges = true;
                    "
                  >
                    <v-list-tile-title>{{ item.category }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
            <td class="lime lighten-3">
                {{ props.item.bruk_av }}
            </td>
            <td class="lime lighten-3">
              <v-edit-dialog :return-value.sync="props.item.measure">
                {{ props.item.measure }}
                <template v-slot:input>
                  <v-text-field
                    :disabled="checkIfPlanIsArchived"
                    v-model="props.item.measure"
                    @input="registeredchanges = true"
                    single-line
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <td class="lime lighten-3">
              <v-edit-dialog :return-value.sync="props.item.responsibility">
                {{ props.item.responsibility }}
                <template v-slot:input>
                  <v-text-field
                    :disabled="checkIfPlanIsArchived"
                    v-model="props.item.responsibility"
                    @input="registeredchanges = true"
                    single-line
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <td class="lime lighten-3">
              <v-btn icon @click="fjern_avd_ovrige_aktiviter(props.item)">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template v-slot:no-data>
            <td colspan="7" class="pa-0">
              <v-alert
                class="black--text ma-0"
                :value="true"
                color="primary lighten-2"
                icon="info"
                >Ingen aktiviteter registrert enda</v-alert
              >
            </td>
          </template>
          <template v-slot:footer>
            <tr>
              <td class="lime lighten-3">
                <v-select
                  :disabled="checkIfPlanIsArchived"
                  :items="maanedsvalg"
                  :label="GET_ORDLYD && GET_ORDLYD.schedule"
                  v-model="newSchedule_avd_ovrige_aktiviter"
                ></v-select>
              </td>
              <td class="lime lighten-3"> 
                <v-text-field 
                  :disabled="checkIfPlanIsArchived" 
                  v-model="newTimeEstimate_avd_ovrige_aktiviter" 
                  type="number"
                  step="0.5"
                  suffix="timer"
                  >
                </v-text-field> 
              </td>
              <td class="lime lighten-3">
                <v-menu
                  v-model="newCategoryMenu_avd_ovrige_aktiviter"
                  :close-on-content-click="true"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn block flat v-on="on" :disabled="checkIfPlanIsArchived">
                      {{
                        newCategory_avd_ovrige_aktiviter ||
                        ("Velg " + GET_ORDLYD &&
                          GET_ORDLYD.category.toLowerCase())
                      }}
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile
                      v-for="(item, index) in plan.categories"
                      :key="index"
                      @click="newCategory_avd_ovrige_aktiviter = item.category"
                    >
                      <v-list-tile-title>{{ item.category }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </td>
              <td></td>
              <td class="lime lighten-3">
                <v-text-field
                  :disabled="checkIfPlanIsArchived"
                  v-model="newMeasure_avd_ovrige_aktiviter"
                  :label="GET_ORDLYD && GET_ORDLYD.measure"
                ></v-text-field>
              </td>
              <td class="lime lighten-3">
                <v-text-field
                  :disabled="checkIfPlanIsArchived"
                  v-model="newResponsibility_avd_ovrige_aktiviter"
                  :label="GET_ORDLYD && GET_ORDLYD.responsibility"
                ></v-text-field>
              </td>
              <td class="lime lighten-3">
                <v-btn icon @click="legg_til_avd_ovrige_aktiviter" :disabled="checkIfPlanIsArchived">
                  <v-icon>add</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>

        <!-- BRUK AV BHT, NALS eller PERSONAL -->
        <h2>{{ GET_ORDLYD && GET_ORDLYD.org_avdeling_hms_activities }}</h2>
        <v-data-table
          class="bruk_av_hms_og_als"
          :items="Response.bruk_av_hms_og_als"
          hide-actions
        >
          <template v-slot:headers>
            <th style="width: 20%;" align="left">
              {{ GET_ORDLYD && GET_ORDLYD.schedule }}
            </th>
            <th style="width: 15%;" align="left">
              {{ GET_ORDLYD && GET_ORDLYD.time_estimate }}
            </th>
            <th style="width: 15%;" align="left">
              {{ GET_ORDLYD && GET_ORDLYD.category }}
            </th>
            <th style="width: 15%;" align="left">
                Bruk av
            </th>
            <th style="width:40%;" align="left">
              {{ GET_ORDLYD && GET_ORDLYD.measure }}
            </th>
            <th style="width:15%;" align="left">
              {{ GET_ORDLYD && GET_ORDLYD.responsibility }}
            </th>

            <th></th>
          </template>
          <template v-slot:no-data>
            <td colspan="7" class="pa-0">
              <v-alert
                class="black--text ma-0"
                :value="true"
                color="primary lighten-2"
                icon="info"
                >Ingen aktiviteter registrert enda</v-alert
              >
            </td>
          </template>
          <template v-slot:items="props">
            <td class="lime lighten-3">
              <v-select
                :disabled="checkIfPlanIsArchived"
                :items="maanedsvalg"
                v-model="props.item.schedule"
              ></v-select>
            </td>
            <td class="lime lighten-3">
              <v-text-field 
                :disabled="checkIfPlanIsArchived"
                v-model="props.item.timeEstimate"
                type="number"
                step="0.5"
                @input="registeredchanges = true"
                suffix="timer"
                single-line>
              </v-text-field>
            </td>

            <td class="lime lighten-3">
              <v-menu
                v-model="props.item.CategoryMenu_bruk_av_hms_og_als"
                :close-on-content-click="true"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-btn block flat v-on="on" :disabled="checkIfPlanIsArchived">
                    {{ props.item.category }}
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile
                    v-for="(item, index) in plan.categories"
                    :key="index"
                    @click="
                      props.item.category = item.category;
                      registeredchanges = true;
                    "
                  >
                    <v-list-tile-title>{{ item.category }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
            <td class="lime lighten-3">
                <v-menu
                  v-model="props.item.BrukAvMenu_bruk_av_hms_og_als"
                  :close-on-content-click="true"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn block flat v-on="on" :disabled="checkIfPlanIsArchived">
                      {{props.item.bruk_av}}
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile
                      v-for="(item, index) in bruk_av"
                      :key="index"
                      @click="
                      props.item.bruk_av = item;
                      registeredchanges = true;
                      " 
                    >
                      <v-list-tile-title>{{ item }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </td>

            <td class="lime lighten-3">
              <v-edit-dialog :return-value.sync="props.item.measure">
                {{ props.item.measure }}
                <template v-slot:input>
                  <v-text-field
                    :disabled="checkIfPlanIsArchived"
                    @input="registeredchanges = true"
                    v-model="props.item.measure"
                    single-line
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>

            <td class="lime lighten-3">
              <v-edit-dialog :return-value.sync="props.item.responsibility">
                {{ props.item.responsibility }}
                <template v-slot:input>
                  <v-text-field
                    :disabled="checkIfPlanIsArchived"
                    @input="registeredchanges = true"
                    v-model="props.item.responsibility"
                    single-line
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <td class="lime lighten-3">
              <v-btn icon @click="fjern_bruk_av_hms_og_als(props.item)" :disabled="checkIfPlanIsArchived">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>

          <template v-slot:footer>
            <tr>
              <td class="lime lighten-3">
                <v-select
                  :disabled="checkIfPlanIsArchived"
                  :items="maanedsvalg"
                  v-model="newSchedule_bruk_av_hms_og_als"
                  label="Tidsplan"
                ></v-select>
              </td>
              <td class ="lime lighten-3">
                <v-text-field
                  :disabled="checkIfPlanIsArchived"
                  v-model="newTimeEstimate_bruk_av_hms_og_als"
                  type="number"
                  step="0.5"
                  suffix="timer"
                ></v-text-field>
              </td>
              <td class="lime lighten-3">
                <v-menu
                  v-model="newCategoryMenu_bruk_av_hms_og_als"
                  :close-on-content-click="true"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn block flat v-on="on" :disabled="checkIfPlanIsArchived">
                      {{
                        newCategory_bruk_av_hms_og_als ||
                        ("Velg " + GET_ORDLYD &&
                          GET_ORDLYD.category.toLowerCase())
                      }}
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile
                      v-for="(item, index) in plan.categories"
                      :key="index"
                      @click="newCategory_bruk_av_hms_og_als = item.category"
                    >
                      <v-list-tile-title>{{ item.category }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </td>

              <td class="lime lighten-3">
                <v-menu
                  v-model="newBrukAvMenu_bruk_av_hms_og_als"
                  :close-on-content-click="true"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn block flat v-on="on" :disabled="checkIfPlanIsArchived">
                      {{
                        newBrukAv_bruk_av_hms_og_als || 
                        ("BRUK AV")
                      }}
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile
                      v-for="(item, index) in bruk_av"
                      :key="index"
                      @click="newBrukAv_bruk_av_hms_og_als = item" 
                    >
                      <v-list-tile-title>{{ item }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </td>
              <td class="lime lighten-3">
                <v-text-field
                  :disabled="checkIfPlanIsArchived"
                  v-model="newMeasure_bruk_av_hms_og_als"
                  label="Tiltak"
                ></v-text-field>
              </td>
              <td class="lime lighten-3">
                <v-text-field
                  :disabled="checkIfPlanIsArchived"
                  v-model="newResponsibility_bruk_av_hms_og_als"
                  label="Ansvar"
                ></v-text-field>
              </td>
              <td class="lime lighten-3">
                <v-btn icon @click="legg_til_bruk_av_hms_og_als" :disabled="checkIfPlanIsArchived">
                  <v-icon>add</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-tab-item>

      <!-- UTFØRE -->
      <v-tab-item>
        <!-- utføre -->
        <h2 pt-3>Kommunens overordna oversikt</h2>
        <v-data-table
          class="overordna_aktivitet"
          :items="overordna_aktivitet"
          hide-actions
        >
          <template v-slot:headers>
            <tr class="green lighten-1">
              <th style="width: 20%;" align="left">
                {{ GET_ORDLYD && GET_ORDLYD.schedule }}
              </th>
              <th style="width: 20%;" align="left">
                {{ GET_ORDLYD && GET_ORDLYD.category }}
              </th>
              <th style="width:55%;" align="left">
                {{ GET_ORDLYD && GET_ORDLYD.measure }}
              </th>
              <th align="left">
                {{ GET_ORDLYD && GET_ORDLYD.responsibility }}
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr class="green lighten-2">
              <td>{{ props.item.schedule }}</td>
              <td>{{ props.item.category }}</td>
              <td>{{ props.item.measure }}</td>
              <td>{{ props.item.responsibility }}</td>
            </tr>
          </template>
        </v-data-table>
        <h2>
          {{ GET_ORDLYD && GET_ORDLYD.org_avdeling_mandatory_activities }}
        </h2>
        <v-data-table class="avd_aktivitet" :items="avd_aktivitet" hide-actions>
          <template v-slot:headers>
            <th style="width: 20%;" align="left">
              {{ GET_ORDLYD && GET_ORDLYD.schedule }}
            </th>
            <th style="width: 15%;" align="left">
              {{ GET_ORDLYD && GET_ORDLYD.category }}
            </th>
            <th style="width:40%;" align="left">
              {{ GET_ORDLYD && GET_ORDLYD.measure }}
            </th>
            <th style="width:15%;" align="left">
              {{ GET_ORDLYD && GET_ORDLYD.responsibility }}
            </th>
            <th>{{ GET_ORDLYD && GET_ORDLYD.done }}</th>
            <th>Notat</th>
          </template>
          <template v-slot:items="props">
            <tr :class="{ 'grey lighten-1': props.item.responsedone }">
              <td>{{ props.item.schedule }}</td>
              <td>{{ props.item.category }}</td>
              <td>{{ props.item.measure }}</td>
              <td>{{ props.item.responsibility }}</td>
              <td :class="{ 'lime lighten-3': !props.item.responsedone }">
                <!-- avd_aktivitet -->
                <template v-if="props.item.responsedone == 0">
                  <v-btn
                    :disabled="checkIfPlanIsArchived"
                    color="info"
                    @click="kvitter_aktivitet(props.item)"
                    round
                    >{{ GET_ORDLYD && GET_ORDLYD.complete }}</v-btn
                  >
                </template>
                <template v-else>
                  <v-menu
                    v-model="props.item.DateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn flat v-on="on" :disabled="checkIfPlanIsArchived">
                        {{ props.item.responsedonedate }}
                      </v-btn>
                    </template>
                    <v-date-picker
                      v-model="props.item.responsedonedate"
                      @input="
                        props.item.DateMenu = false;
                        registeredchanges = true;
                      "
                    ></v-date-picker>
                  </v-menu>
                </template>
              </td>
              <td><v-icon class="text-xs-center" @click="openNoteDialog(props.item, 'this.plan.activities')" title="Rediger notat">edit_note</v-icon></td>
            </tr>
          </template>
        </v-data-table>

        <!-- avd_ovrige_aktiviter -->
        <template v-if="Response.avd_ovrige_aktiviter.length > 0">
          <h2>{{ GET_ORDLYD && GET_ORDLYD.org_avdeling_other_activities }}</h2>

          <v-data-table
            class="avd_ovrige_aktiviter"
            :items="Response.avd_ovrige_aktiviter"
            hide-actions
          >
            <template v-slot:headers>
              <th style="width: 20%;" align="left">
                {{ GET_ORDLYD && GET_ORDLYD.schedule }}
              </th>
              <th style="width: 15%;" align="left">
                {{ GET_ORDLYD && GET_ORDLYD.category }}
              </th>
              <th style="width:40%;" align="left">
                {{ GET_ORDLYD && GET_ORDLYD.measure }}
              </th>
              <th style="width:15%;" align="left">
                {{ GET_ORDLYD && GET_ORDLYD.responsibility }}
              </th>
              <th>{{ GET_ORDLYD && GET_ORDLYD.done }}</th>
              <th>Notat</th>
            </template>
            <template v-slot:items="props">
              <tr :class="{ 'grey lighten-1': props.item.responsedone }">
                <td>{{ props.item.schedule }}</td>
                <td>{{ props.item.category }}</td>
                <td>{{ props.item.measure }}</td>
                <td>{{ props.item.responsibility }}</td>
                <td :class="{ 'lime lighten-3': !props.item.responsedone }">
                  <template v-if="props.item.responsedone == 0">
                    <v-btn
                      :disabled="checkIfPlanIsArchived"
                      color="info"
                      @click="kvitter_aktivitet(props.item)"
                      round
                      >{{ GET_ORDLYD && GET_ORDLYD.complete }}</v-btn
                    >
                  </template>
                  <template v-else>
                    <v-menu
                      v-model="props.item.DateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn flat v-on="on" :disabled="checkIfPlanIsArchived">
                          {{ props.item.responsedonedate }}
                        </v-btn>
                      </template>
                      <v-date-picker
                        v-model="props.item.responsedonedate"
                        @input="
                          props.item.DateMenu = false;
                          registeredchanges = true;
                        "
                      ></v-date-picker>
                    </v-menu>
                  </template>
                </td>
                <td><v-icon class="text-xs-center" @click="openNoteDialog(props.item,'this.Response.avd_ovrige_aktiviter')" title="Rediger notat">edit_note</v-icon></td>
              </tr>
            </template>
          </v-data-table>
        </template>

        <template v-if="Response.bruk_av_hms_og_als.length > 0">
          <h2>{{ GET_ORDLYD && GET_ORDLYD.org_avdeling_hms_activities }}</h2>
          <v-data-table
            class="bruk_av_hms_og_als"
            :items="Response.bruk_av_hms_og_als"
            hide-actions
          >
            <template v-slot:headers>
              <th style="width: 20%;" align="left">
                {{ GET_ORDLYD && GET_ORDLYD.schedule }}
              </th>
              <th style="width: 15%;" align="left">
                {{ GET_ORDLYD && GET_ORDLYD.category }}
              </th>
              <th style="width: 15%;" align="left">
                Bruk av
              </th>
              <th style="width:40%;" align="left">
                {{ GET_ORDLYD && GET_ORDLYD.measure }}
              </th>
              <th style="width:15%;" align="left">
                {{ GET_ORDLYD && GET_ORDLYD.responsibility }}
              </th>
              <th>{{ GET_ORDLYD && GET_ORDLYD.done }}</th>
              <th>Notat</th>
            </template>
            <template v-slot:items="props">
              <tr :class="{ 'grey lighten-1': props.item.responsedone }">
                <td>{{ props.item.schedule }}</td>
                <td>{{ props.item.category }}</td>
                <td>{{ props.item.bruk_av }}</td>
                <td>{{ props.item.measure }}</td>
                <td>{{ props.item.responsibility }}</td>
                <td :class="{ 'lime lighten-3': !props.item.responsedone }">
                  <!-- bruk_av_hms_og_als -->
                  <template v-if="props.item.responsedone == 0">
                    <v-btn
                      :disabled="checkIfPlanIsArchived"
                      color="info"
                      @click="kvitter_aktivitet(props.item)"
                      round
                      >{{ GET_ORDLYD && GET_ORDLYD.complete }}</v-btn
                    >
                  </template>
                  <template v-else>
                    <v-menu
                      v-model="props.item.DateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn flat v-on="on" :disabled="checkIfPlanIsArchived">
                          {{ props.item.responsedonedate }}
                        </v-btn>
                      </template>
                      <v-date-picker
                        v-model="props.item.responsedonedate"
                        @input="
                          props.item.DateMenu = false;
                          registeredchanges = true;
                        "
                      ></v-date-picker>
                    </v-menu>
                  </template>
                </td>
                <td><v-icon class="text-xs-center" @click="openNoteDialog(props.item, 'this.Response.bruk_av_hms_og_als')" title="Rediger notat">edit_note</v-icon></td>
              </tr>
            </template>
          </v-data-table>
        </template>
      </v-tab-item>
    </v-tabs>
    <v-dialog v-model="loadingDialog" persistent width="300">
      <v-card round>
        <v-card-text>
          Vennligst vent mens vi lagrer data.
          <v-progress-linear
            indeterminate
            color="primary"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog width="800px" v-model="editNoteDialog" persistent>
      <v-card class="pt-1 pl-3 pb-3 pr-3" v-if="currentNoteEditObject">
        <div class="text-xs-right">
          <v-icon
            large
            @click="closeNoteDialog"
            title="Lukk(endringer blir ikke lagret)"
            >close</v-icon
          >
        </div>
        <v-textarea
          :disabled="checkIfPlanIsArchived"
          style="border: 1px dashed lightgrey"
          counter="1000"
          max-length="1000"
          label="Legg til notat eller endre notat"
          rows="15"
          v-model="currentNoteEditObject.note"
        ></v-textarea>
        <v-btn
          @click="doneEditNote"
          :disabled="
            currentNoteEditObject.note == currentNoteEditObject.oldNote
          "
          >Ferdig</v-btn
        >
      </v-card>

    </v-dialog>
    <div id="buttonwrapper" v-if="registeredchanges">
      <v-btn v-if="plan.planning.active == true" color="success" @click="saveResponse">Lagre</v-btn>
      <v-btn v-else color="warning" @click="resetResponse">Avbryt</v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import Doc from "./components/Doc.js";
import Title from "./components/Title.js";
import {
  Placeholder,
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from "tiptap-extensions";
export default {
  components: {
    EditorContent,
    EditorMenuBar,
  },
  methods: {
    ...mapActions(["GET_USER_PLAN", "ALTER_PLAN", "ALTER_RESPONSE"]),
    openNoteDialog(item, belongsToPath) {
      this.currentNoteEditObject = {
        id: item.id,
        note: item.responsenote,
        oldNote: item.responsenote,
        belongsToPath: belongsToPath,
      };
      this.editNoteDialog = true;
    },
    closeNoteDialog() {
      this.currentNoteEditObject = null;
      this.editNoteDialog = false;
    },
    doneEditNote() {
      let noteBelongsToArray = eval(this.currentNoteEditObject.belongsToPath);
      let findCorrectActivity = noteBelongsToArray.find(
        (i) => i.id == this.currentNoteEditObject.id
      );
      findCorrectActivity.responsenote = this.currentNoteEditObject.note;
      this.currentNoteEditObject = null;
      this.editNoteDialog = false;
      this.registeredchanges = true;
    },
    kvitter_aktivitet(item) {
      item.responsedone = 1;
      item.responsedonedate = new Date().toISOString().substr(0, 10);
      this.registeredchanges = true;
    },
    legg_til_avd_ovrige_aktiviter() {
      let _insert = {
        id: "tmp" + new Date().valueOf().toString(16),
        schedule: this.newSchedule_avd_ovrige_aktiviter,
        timeEstimate: this.newTimeEstimate_avd_ovrige_aktiviter,
        category: this.newCategory_avd_ovrige_aktiviter,
        measure: this.newMeasure_avd_ovrige_aktiviter,
        responsibility: this.newResponsibility_avd_ovrige_aktiviter,
        responsedone: 0,
        responsedonedate: null,
        DateMenu: false,
        level: "avd_ovrige_aktiviter",
      };
      this.Response.avd_ovrige_aktiviter.push(_insert);
      this.newSchedule_avd_ovrige_aktiviter = "";
      this.newTimeEstimate_avd_ovrige_aktiviter = null;
      // this.newCategory = "";
      this.newCategory_avd_ovrige_aktiviter = "";
      this.newCategoryMenu_avd_ovrige_aktiviter = false;
      this.newMeasure_avd_ovrige_aktiviter = "";
      this.newResponsibility_avd_ovrige_aktiviter = "";
      this.registeredchanges = true;
    },
    fjern_avd_ovrige_aktiviter(aktivitet) {
      this.Response.avd_ovrige_aktiviter = this.Response.avd_ovrige_aktiviter.filter(
          (res) => res.id != aktivitet.id
        );
      this.registeredchanges = true;
    },
    legg_til_bruk_av_hms_og_als() {
      
      let _insert = {
        id: "tmp" + new Date().valueOf().toString(16),
        schedule: this.newSchedule_bruk_av_hms_og_als,
        timeEstimate: this.newTimeEstimate_bruk_av_hms_og_als,
        category: this.newCategory_bruk_av_hms_og_als,
        measure: this.newMeasure_bruk_av_hms_og_als,
        responsibility: this.newResponsibility_bruk_av_hms_og_als,
        bruk_av: this.newBrukAv_bruk_av_hms_og_als,
        level: "bruk_av_hms_og_als",
        responsedone: 0,
        responsedonedate: null,
        DateMenu: false,
      };
      this.Response.bruk_av_hms_og_als.push(_insert);
      this.registeredchanges = true;
      this.newSchedule_bruk_av_hms_og_als = "";
      this.newTimeEstimate_bruk_av_hms_og_als = null;
      this.newCategory_bruk_av_hms_og_als = "";
      this.newMeasure_bruk_av_hms_og_als = "";
      this.newResponsibility_bruk_av_hms_og_als = "";
      this.newBrukAv_bruk_av_hms_og_als = "";
      this.registeredchanges = true;
    },
    fjern_bruk_av_hms_og_als(aktivitet) {
      this.Response.bruk_av_hms_og_als = this.Response.bruk_av_hms_og_als.filter(
          (res) => res.id != aktivitet.id
        );
      this.registeredchanges = true;
    },
    editShort(item) {
      item.shorteditmode = true;
      this.$nextTick(() => this.$refs[item.name + "_short_ref"].focus());
    },
    editLong(item) {
      item.longeditmode = true;
      this.$nextTick(() => this.$refs[item.name + "_long_ref"].focus());
    },
    submitEditPlan() {
      this.loadingDialog = true;
      let _newPlan = {
        id: this.plan.planning["id"],
        title: this.planTitle,
        description: this.planEditors.planDescription.getHTML(),
        avd_maalsetting: this.planEditors.planAvdMaal.getHTML(),
        overordna_maalsetting: this.planEditors.planOverordnaMaal.getHTML(),
        activities: this.plan.activities,
        evaluationtasks: this.plan.evaluationtasks,
      };
      this.ALTER_PLAN({
        planid: _newPlan.id,
        customerid: this.GET_USER.customerid,
        Transfer: "editplan",
        data: _newPlan,
      })
        .then((resp) => {})
        .finally(() => {
          this.dialogAlterDepartment = false;
          this.loadingDialog = false;
          this.registeredchanges = false;
          this.getPlan();
        });
    },
    resetResponse() {
      this.getPlan();
    },
    getPlan() {
      this.GET_USER_PLAN(this.GET_MANUALLYSELECTEDPLAN)
        .then((res) => {
          this.loadingDialog = false;
          this.registeredchanges = false;
          this.plan = res.data;
          this.plan.activities = this.plan.activities.map((res) => {
            return {
              ...res,
              schedule: res.responseschedule
                ? res.responseschedule
                : res.schedule,
              category: res.responsecategory
                ? res.responsecategory
                : res.category,

              DateMenu: false,
              responsedonedate: res.responsedonedate
                ? res.responsedonedate.slice(0, 10)
                : res.responsedate,
              CategoryMenu_avd_aktivitet: false,
              CategoryMenu_avd_ovrige_aktiviter: false,
              CategoryMenu_bruk_av_hms_og_als: false,
              BrukAvMenu_bruk_av_hms_og_als: false,
            };
          });
          this.Response.avd_ovrige_aktiviter = this.plan.custom_activities
            .filter(
              (element) => element.responselevel == "avd_ovrige_aktiviter"
            )
            .map((element) => {
              return {
                id: element.id,
                schedule: element.responseschedule,
                category: element.responsecategory,
                measure: element.responsemeasure,
                responsibility: element.responseresponsibility,
                responsedone: element.responsedone,
                responsedonedate: element.responsedonedate
                ? element.responsedonedate.slice(0, 10)
                : element.responsedate,
                responsenote: element.responsenote,
                DateMenu: false,
                level: element.responselevel,
                bruk_av: element.responsebrukav,
                timeEstimate: element.responsetimeestimate,
              };
            });
          this.Response.bruk_av_hms_og_als = this.plan.custom_activities
            .filter((element) => element.responselevel == "bruk_av_hms_og_als")
            .map((element) => {
              return {
                id: element.id,
                schedule: element.responseschedule,
                category: element.responsecategory,
                measure: element.responsemeasure,
                responsibility: element.responseresponsibility,
                responsedone: element.responsedone,
                responsedonedate: element.responsedonedate
                ? element.responsedonedate.slice(0, 10)
                : element.responsedate,
                responsenote: element.responsenote,
                DateMenu: false,
                level: element.responselevel,
                bruk_av: element.responsebrukav,
                timeEstimate: element.responsetimeestimate,
              };
            });
          this.planDataIsRetrieved = true;
          this.planTitle = this.plan.planning["title"];
          this.planDescription = this.plan.planning["description"].replace(
            "#avdeling#",
            this.plan.avdeling.label
          );
          this.planEditors.planDescription.setContent(
            this.plan.planning["description"]
          );
          this.planEditors.planOverordnaMaal.setContent(
            this.plan.planning["overordna_maalsetting"]
          );
          this.planEditors.planAvdMaal.setContent(
            this.plan.planning["avd_maalsetting"]
          );
          this.Response.sector_id = this.plan.avdeling.sector_id;
          this.Response.area_id = this.plan.avdeling.area_id;
          this.Response.org_id = this.plan.avdeling.id;

          this.Response.planningid = this.plan.planning.id;
          this.Response.ParentOrg = this.plan.avdeling.area_label || "";
          this.Response.Org =
            (this.plan.avdeling && this.plan.avdeling.label) || "";

          this.Response.Date =
            (this.plan.planning.responsedate &&
              this.plan.planning.responsedate.slice(0, 10)) ||
            new Date().toISOString().slice(0, 10);
          this.Response.Place = this.plan.planning.responseplace || "";
          this.Response.Participants =
            this.plan.planning.responseparticipants || "";

          this.Response.avd_maal_frafall_reduksjon =
            (this.plan.response && this.plan.response.organisationtarget) || "";
          this.Response.avd_delmaal_frafall_reduksjon =
            (this.plan.response && this.plan.response.organisationsubtargets) ||
            "";

          let targetnumber3years = this.absenceGoals.find(
            (element) => element.name == "targetnumber3years"
          );
          targetnumber3years.longabsence =
            (this.plan.response &&
              this.plan.response.targetnumber3years_long) ||
            "100";
          targetnumber3years.shortabsence =
            (this.plan.response &&
              this.plan.response.targetnumber3years_short) ||
            "100";

          let targetnumber2years = this.absenceGoals.find(
            (element) => element.name == "targetnumber2years"
          );
          targetnumber2years.longabsence =
            (this.plan.response &&
              this.plan.response.targetnumber2years_long) ||
            "100";
          targetnumber2years.shortabsence =
            (this.plan.response &&
              this.plan.response.targetnumber2years_short) ||
            "100";

          let targetnumber1years = this.absenceGoals.find(
            (element) => element.name == "targetnumber1years"
          );
          targetnumber1years.longabsence =
            (this.plan.response &&
              this.plan.response.targetnumber1years_long) ||
            "100";
          targetnumber1years.shortabsence =
            (this.plan.response &&
              this.plan.response.targetnumber1years_short) ||
            "100";

          let absencecurrenthalfyear = this.absenceGoals.find(
            (element) => element.name == "absencecurrenthalfyear"
          );
          absencecurrenthalfyear.longabsence =
            (this.plan.response &&
              this.plan.response.absencecurrenthalfyear_long) ||
            "100";
          absencecurrenthalfyear.shortabsence =
            (this.plan.response &&
              this.plan.response.absencecurrenthalfyear_short) ||
            "100";

          let absence1years = this.absenceGoals.find(
            (element) => element.name == "absence1years"
          );
          absence1years.longabsence =
            (this.plan.response && this.plan.response.absence1years_long) ||
            "100";
          absence1years.shortabsence =
            (this.plan.response && this.plan.response.absence1years_short) ||
            "100";

          let absence2years = this.absenceGoals.find(
            (element) => element.name == "absence2years"
          );
          absence2years.longabsence =
            (this.plan.response && this.plan.response.absence2years_long) ||
            "100";
          absence2years.shortabsence =
            (this.plan.response && this.plan.response.absence2years_short) ||
            "100";

          this.plan.evaluationtasks.map((element) => {
            element.completed =
              element.completed == "1" ? 1 : element.completed == "2" ? 2 : 0;
            return element;
          });
        })
        .catch((e) => {
          console.error(e);
        });
    },
    setTimeToResponseDate(item){
      if(item){
        return item + " " + "12:00:00"
      }
      else{
        return null
      }
    },
    saveResponse() {
      let ResponseData = {
        Transfer: "saveresponse",
        data: {
          ...this.Response,
          absenceGoals: this.absenceGoals,
          evaluationtasks: this.plan.evaluationtasks,
          activities: this.plan.activities
          .concat(
            this.Response.avd_ovrige_aktiviter,
            this.Response.bruk_av_hms_og_als
            )
            .map((res) => {
              return {
                id: res.id,
                schedule: res.schedule,
                timeEstimate: res.timeEstimate === "" ? null : res.timeEstimate,
                category: res.category,
                responsibility: res.responsibility,
                label: res.label,
                level: res.level,
                measure: res.measure,
                planningid: res.planningid,
                responsedone: res.responsedone,
                responsedonedate: this.setTimeToResponseDate(res.responsedonedate),
                responsenote: res.responsenote,
                brukAv: res.bruk_av,
              };
            }),
          },
        };
        if(this.Response.Date){
          ResponseData.data.Date = this.Response.Date + " " + "12:00:00"
        }
      console.log('responsedata plan-detail: ', )
      this.ALTER_RESPONSE(ResponseData).then((res) => {
        this.registeredchanges = false;
      });
    },
  },
  data() {
    return {
      activeTab: 0,
      noteDialog: false,
      noteText: '',
      noteItem: null,
      maanedsvalg: [
        "Månedlig",
        "Jevnlig",
        "Januar",
        "Februar",
        "Mars",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Desember",
        "Neste år",
      ],
      bruk_av: [
        "Bedriftshelsetjeneste",
        "Arbeidslivstjeneste",
        "Personal",
        "Annet"
      ],
      newTimeEstimate_avd_ovrige_aktiviter: null,
      newTimeEstimate_bruk_av_hms_og_als: null,
      Response: {
        planningid: 0,
        ParentOrg: "",

        Org: "",
        Place: "",
        Date: new Date().toISOString().substr(0, 10),
        Participants: "",
        avd_ovrige_aktiviter: [],
        bruk_av_hms_og_als: [],
        avd_maal_frafall_reduksjon: "",
        avd_delmaal_frafall_reduksjon: "",
        org_id: 0,
        sector_id: 0,
        area_id: 0,
      },
      absenceHeaders: [],
      absenceGoals: [
        {
          name: "targetnumber3years",
          label: "Måltall 2026",
          shortabsence: 100,
          longabsence: 100,
          shorteditmode: false,
          longeditmode: false,
        },
        {
          name: "targetnumber2years",
          label: "Måltall 2025",
          shortabsence: 100,
          longabsence: 100,
          shorteditmode: false,
          longeditmode: false,
        },
        {
          name: "targetnumber1years",
          label: "Målltall 2024",
          shortabsence: 100,
          longabsence: 100,
          shorteditmode: false,
          longeditmode: false,
        },
        {
          name: "absencecurrenthalfyear",
          label: "Nærvær 2023",
          shortabsence: 100,
          longabsence: 100,
          shorteditmode: false,
          longeditmode: false,
        },
        {
          name: "absence1years",
          label: "Nærvær 2022",
          shortabsence: 100,
          longabsence: 100,
          shorteditmode: false,
          longeditmode: false,
        },
        {
          name: "absence2years",
          label: "Nærvær 2021",
          shortabsence: 100,
          longabsence: 100,
          shorteditmode: false,
          longeditmode: false,
        },
      ],
      editNoteDialog: false,
      currentNoteEditObject: null,
      DateMenu: false,
      loadingDialog: false,
      registeredchanges: false,
      planDataIsRetrieved: false,
      plan: {},
      planTitle: "",
      planDescription: "",
      planOverordnaMaal: "",
      planAvdMaal: "",
      newEvaluation: "",

      newSchedule_bruk_av_hms_og_als: "",
      newBrukAv_bruk_av_hms_og_als: "",
      newMeasure_bruk_av_hms_og_als: "",
      newCategory_bruk_av_hms_og_als: "",
      newResponsibility_bruk_av_hms_og_als: "",
      newCategoryMenu_bruk_av_hms_og_als: false,
      newBrukAvMenu_bruk_av_hms_og_als: false,
      newSchedule_avd_ovrige_aktiviter: "",
      newMeasure_avd_ovrige_aktiviter: "",
      newCategory_avd_ovrige_aktiviter: "",
      newResponsibility_avd_ovrige_aktiviter: "",
      newCategoryMenu_avd_ovrige_aktiviter: false,
      planEditors: {
        planDescription: new Editor({
          extensions: [
            new Bold(),
            new Heading({ levels: [1, 2, 3] }),
            new BulletList(),
            new OrderedList(),
            new ListItem(),
            new TodoItem(),
            new TodoList(),
            new History(),
          ],
          editable: true,
          content: ``,
          onUpdate: () => {
            this.registeredchanges = true;
          },
        }),
        planOverordnaMaal: new Editor({
          extensions: [
            new Bold(),
            new Heading({ levels: [1, 2, 3] }),
            new BulletList(),
            new OrderedList(),
            new ListItem(),
            new TodoItem(),
            new TodoList(),
            new History(),
          ],
          editable: true,
          content: ``,
          onUpdate: () => {
            this.registeredchanges = true;
          },
        }),
        planAvdMaal: new Editor({
          extensions: [
            new Bold(),
            new Heading({ levels: [1, 2, 3] }),
            new BulletList(),
            new OrderedList(),
            new ListItem(),
            new TodoItem(),
            new TodoList(),
            new History(),
          ],
          editable: true,
          content: ``,
          onUpdate: () => {
            this.registeredchanges = true;
          },
        }),
      },
    };
  },
  computed: {
    ...mapGetters(["GET_USER", "GET_ORDLYD","GET_MANUALLYSELECTEDPLAN"]),
    overordna_aktivitet() {
      return this.plan.activities.filter((res) => res.level == "kommune");
    },
    avd_aktivitet() {
      return this.plan.activities.filter((res) => res.level == "avdeling");
    },
    checkIfDepartmentIsArchived() {
      if (this.plan && this.plan.avdeling.sector_id == 10) {
        return true
      }
      else {
        return false
      }
    },
    checkIfPlanIsArchived() {
      if (this.plan && this.plan.planning.active == 0) {
        return true
      }
      else {
        return false
      }
    }
  },
  created() {
    if (this.$route.query.tab === 'planlegge') {
      this.activeTab = 3;
    }
  },
  mounted() {
    this.getPlan();
  },
  beforeDestroy() {
    this.planEditors.planDescription.destroy();
    this.planEditors.planOverordnaMaal.destroy();
    this.planEditors.planAvdMaal.destroy();
  },
  beforeRouteLeave(to, from, next) {
    if (this.registeredchanges) {
      const answer = window.confirm(
        "Er du sikker på at du ønsker å forlate siden? Du har endringer som ikke er lagret."
      );
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
};
</script>

<style>
.ProseMirror {
  background-color: rgba(0, 0, 0, 0.06);
  padding: 20px 10px;
}
.is-hidden {
  visibility: hidden;
}
.is-hidden.is-focused {
  visibility: visible;
}

.overordna_aktivitet td,
.avd_aktivitet td,
.avd_aktivitet td.lime.lighten-3,
.avd_ovrige_aktiviter td,
.avd_ovrige_aktiviter td.lime.lighten-3,
.bruk_av_hms_og_als td,
.bruk_av_hms_og_als td.lime.lighten-3 {
  outline: 1px solid black !important;
  outline-offset: -2px;
}

#buttonwrapper {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 999;
}

h2 {
  padding: 20px 0;
}
</style>
